import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MainComponentsModule } from 'app/_main/modules/main-components.module';
import { ButtonModule } from 'core/components/button/button.module';
import { DataExpandModule } from 'core/components/data-expand/data-expand.module';
import { DropdownModule } from 'core/components/dropdown/dropdown.module';
import { InputModule } from 'core/components/input/input.module';
import { RangeModule } from 'core/components/range/range.module';
import { TranslateModule } from 'core/modules/i18n/translate.module';
import { PlatformModule } from 'core/modules/platform/platform.module';
import { ScrollerModule } from 'core/modules/scroller/scroller.module';

import { StreetSearchFormComponent } from '../components/_ui/street-search-form/street-search-form.component';
import { StreetSuggestionItemComponent } from '../components/_ui/street-suggestion-item/street-suggestion-item.component';
import { MapComponent } from '../components/map/map.component';

const exportedDeclarations = [
  MapComponent,
  StreetSearchFormComponent,
  StreetSuggestionItemComponent,
];

@NgModule({
  declarations: [...exportedDeclarations],
  exports: [...exportedDeclarations],
  imports: [
    CommonModule,
    PlatformModule,
    ReactiveFormsModule,
    RangeModule,
    TranslateModule,
    DataExpandModule,
    ButtonModule,
    InputModule,
    DropdownModule,
    ScrollerModule,
    MainComponentsModule,
  ],
})
export class StreetsMapModule {}
